import React from "react";
import { Link } from "react-router-dom";
import { btnPrimary } from "@/components/site/buttons";
import { Overline, Rule } from "@/components/site/Primitives";

export function ConsultCTA({ heading, body, compact = false }) {
  return (
    <section className={`relative overflow-hidden bg-ink text-cream-100 ${compact ? "py-14" : "py-24"}`} data-testid="consult-cta">
      <div className="absolute -right-10 top-1/2 hidden -translate-y-1/2 select-none font-serif text-[16rem] leading-none text-cream-100/[0.04] lg:block">
        GF
      </div>
      <div className="mx-auto max-w-3xl px-5 text-center">
        <Overline className="text-gold-400">Goldman Fischer</Overline>
        <Rule className="mx-auto my-5" />
        <h2 className="font-serif text-3xl font-light leading-tight sm:text-4xl">
          {heading || "Ready to think it through together?"}
        </h2>
        <p className="mx-auto mt-4 max-w-xl font-sans text-base leading-relaxed text-cream-100/75">
          {body || "Request a consultation to discuss your situation in confidence."}
        </p>
        <Link to="/contact" className={`mt-8 ${btnPrimary}`} data-testid="cta-consult-button">
          Request a Consultation
        </Link>
      </div>
    </section>
  );
}
